import * as React from "react";
import { Eye } from "@rista/ui/library/icons/glyphs";

// The drawing is the design system's icon glyph (`@rista/ui/library/icons/glyphs`, DESIGN_SYSTEM.md QD10); this keeps
// this file's import path and the size and colour it always drew, so its callers render exactly as before.
// Its callers size it with `width` and `height` (always equal); the glyph is square.
// eslint-disable-next-line no-unused-vars -- `height` is accepted and equal to `width`
function EyeIcon({ color = "#12141A", width = 24, height }) {
  return <Eye size={width} color={color} />;
}

export default EyeIcon;
